/**
 * Plan 04-03 — types alineados con backend FeedbackRequest (Task 1 commit).
 * Single source of truth: src/farmacia/api/feedback.py FeedbackRequest.
 *
 * D-UI-FB-01: 5 categorías cuando vote=down. correct también es válido por
 * symmetria (la farmacéutica puede 👍 + categorizar como "correct"); sigue el
 * mismo schema backend para no introducir un Literal subset frontend que se
 * desfase.
 */

// 20-oct: "¿Lo vendiste?" en las respuestas con producto
export type FeedbackVote = 'up' | 'down' | 'vendido' | 'otro_producto' | 'no_vendido'

export type FeedbackCategory =
  | 'correct'
  | 'partial'
  | 'wrong_dose'
  | 'wrong_pa'
  | 'other'
  | 'caro'
  | 'sin_stock'
  | 'solo_consulta'
  | 'no_servia'

export interface FeedbackPayload {
  /** 2026-10-01 — id de la consulta (registro propio); trace_id de Langfuse opcional. */
  consulta_id?: string | null
  trace_id?: string | null
  vote: FeedbackVote
  category?: FeedbackCategory
  comment?: string
  device_id: string
}

/**
 * Labels ES-BO Drimian per UI-SPEC § Copywriting Feedback. NO em-dash, NO
 * paternalismo "Lo siento/Disculpe". Frontend-only — backend nunca recibe
 * esto, solo el código del Literal.
 */
export const FEEDBACK_CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  correct: 'Correcto',
  partial: 'Parcial',
  wrong_dose: 'Dosis equivocada',
  wrong_pa: 'PA equivocado',
  other: 'Otro',
  caro: 'Caro',
  sin_stock: 'No había',
  solo_consulta: 'Solo consultaba',
  no_servia: 'No servía la sugerencia',
}
